import './App.css';
import { Nav, Navbar, Dropdown} from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import myImage from  './images/hritik.jpg'
import { Button } from 'react-bootstrap';
import headImage from './images/intro.png'
import logo from './images/logo.png'
import { SocialIcon } from 'react-social-icons';
import { useState } from 'react';
import styled, { ThemeProvider } from 'styled-components';
import {lightTheme, darkTheme, GlobalStyles} from './theme';
import MyPDF from './assets/HritikPawarResume.pdf';
//import { Route, Switch, Redirect } from 'react-router-dom';
//import { BrowserRouter as Router, Switch, Route } from "react-router-dom"
const StyledApp = styled.div`
  color: ${(props) => props.theme.fontColor};
`;

function App() {
  const [theme, settheme] = useState("light")
  const [variant, setvariant] = useState("light")
  const themetoggler = () => {
    theme === "light" ? settheme("dark") : settheme("light");
    variant === "light" ? setvariant("dark") : setvariant("light");
  }
  return (
    <ThemeProvider theme={theme === "light" ? lightTheme : darkTheme}>
    <GlobalStyles/>
    <StyledApp>
    <div className="App">
      <body className="body">
        <Navbar collapseOnSelect bg="transparent" expand="lg" variant="dark" className="nav">
          <Navbar.Brand href="#home" className="logo">
            Hritik Pawar
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="mr-auto links">
              <Nav.Link href="#features">Work</Nav.Link>
              <Nav.Link href="#pricing">About</Nav.Link>
              <Nav.Link href="#deets">Contact</Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
        <div className="main">
          <img src={headImage} className="topimage" alt="head-image" width="62%"/>
          <div className="intro-head">
            Hello, I am Hritik Pawar a Full Stack Developer.
          </div>
          <div className="intro-main">
          <hr/>
           <div className="profile"><div className="name"><h1>Hritik Pawar</h1><p>(Developer/Blogger)</p></div><img className="profilepic" src={myImage} alt="profile-picture" height="100px" /></div> 
            <hr/>
            <div className="about">
            <p>Hritik Pawar is a Student and a Web Developer, I am a B.Sc Computer Science Graduate in year 2021 from Vartak College affiliated to Mumbai University currently he is pursuing his Masters in Computer Science, He loves developing Website and creating new Web Products that enhance usage of Web.
              He likes minimalism and belives there is more power in Simplicity. He has always been an creative art enthusiast and practiciner, and loves to use this creativity in his work.
            </p>
            <p>Check <a>About</a> to know more about me..</p></div>
            <Button className="btn" href={MyPDF} download="HritikPawarResume.pdf">Download Resume</Button>
          </div>
        </div>
        <div className="footer">
          <div className="footer-SocialTab">
          <SocialIcon className="SocialIcon" url="https://twitter.com/iamhritikpawar" target="_blank" />
          <SocialIcon className="SocialIcon" url="https://instagram.com/unlikelycreator" target="_blank"/>
          <SocialIcon className="SocialIcon" url="https://github.com/unlikelycreator" target="_blank"/>
          <SocialIcon className="SocialIcon" url="https://www.linkedin.com/in/hritik-pawar-07810321a/?trk=public-profile-join-pager" target="_blank"/>
          <SocialIcon className="SocialIcon" url="email.com" onClick={(e) => {e.preventDefault(); alert("Email copied to ClipBoard"); navigator.clipboard.writeText('hritikpawar.personal@gmail.com')}} />
          <SocialIcon className="SocialIcon" url="https://open.spotify.com/user/pawarhritik2700" target="_black"/>
          </div>
          <div className="copyright">
            <p>All Rights Reserved <b><i>@iamhritikpawar</i></b></p>
          </div>
        </div>
      </body>
      <div className="socialTab">
        <SocialIcon url="https://twitter.com/iamhritikpawar" target="_blank" />
        <SocialIcon url="https://instagram.com/unlikelycreator" target="_blank"/>
        <SocialIcon url="https://github.com/unlikelycreator" target="_blank"/>
        <SocialIcon url="https://www.linkedin.com/in/hritik-pawar-07810321a/?trk=public-profile-join-pager" target="_blank"/>
        <SocialIcon url="https://open.spotify.com/user/pawarhritik2700" target="_black"/>
        <SocialIcon url="email.com" onClick={(e) => {e.preventDefault(); alert("Email copied to ClipBoard"); navigator.clipboard.writeText('hritikpawar.personal@gmail.com')}} />
      </div>
    </div>
    </StyledApp>
    </ThemeProvider>
  );
}

export default App;
